import colors from './colors';

const gradients = {
  'gradient-default': `linear-gradient(to right, ${colors['orange-light']}, ${colors.orange} 50%, ${colors['orange-light']})`,
} as const;

export default gradients;
